import { createContext } from "react"
import { Theme } from "../../../types/global/themeTypes";

type Props = {
  theme: Theme,
  navbarIsCollapsed: boolean,
  isMobileMenuOpen: boolean,
  toggleTheme: () => void,
  setNavbarIsCollapsed: React.Dispatch<React.SetStateAction<boolean>>,
  setIsMobileMenuOpen: React.Dispatch<React.SetStateAction<boolean>>,
  setNoticeOpen: React.Dispatch<React.SetStateAction<boolean>>,
  setMessageNotice: React.Dispatch<React.SetStateAction<string>>
}

export const AppContext = createContext<Props>(null!);